export default {
  methods: {
    closeModalAndRedirect(route) {
      document.body.classList.remove('modal-open');

      const backdrop = document.querySelectorAll('.modal-backdrop');
      backdrop.forEach(el => el.remove());

      this.$router.push(route);
    },
    closeModal() {
      document.body.classList.remove('modal-open');

      const backdrop = document.querySelectorAll('.modal-backdrop');
      backdrop.forEach(el => el.remove());
    }
  }
}
